export const data = [
  {
    question: 'What are props in React?',
    relatedField: 'Software / IT',
    level: 'Associate',
    jobTitle: 'Associate Frontend Engineer',
  },
  {
    question: 'What is subnetting in networking?',
    relatedField: 'Networking',
    level: 'Junior',
    jobTitle: 'Network Engineer',
  },
  {
    question: 'What are the principles of UI/UX design?',
    relatedField: 'Web UI',
    level: 'Mid-Level',
    jobTitle: 'UI/UX Designer',
  },
  {
    question: 'What are the key responsibilities of an HR manager?',
    relatedField: 'HR',
    level: 'Senior',
    jobTitle: 'HR Manager',
  },
  {
    question: 'What is patient-centered care in nursing?',
    relatedField: 'Nursing',
    level: 'Associate',
    jobTitle: 'Registered Nurse',
  },
  {
    question: 'What is React Router?',
    relatedField: 'Software / IT',
    level: 'Associate',
    jobTitle: 'Associate Frontend Engineer',
  },
  {
    question: 'Explain TCP/IP model layers.',
    relatedField: 'Networking',
    level: 'Mid-Level',
    jobTitle: 'Network Administrator',
  },
  {
    question: 'What is usability testing in UI/UX?',
    relatedField: 'Web UI',
    level: 'Mid-Level',
    jobTitle: 'UX Researcher',
  },
  {
    question: 'What are the benefits of diversity in the workplace?',
    relatedField: 'HR',
    level: 'Senior',
    jobTitle: 'HR Business Partner',
  },
  {
    question: 'What are vital signs in nursing?',
    relatedField: 'Nursing',
    level: 'Intern',
    jobTitle: 'Nursing Intern',
  },
  {
    question: 'What is the difference between state and props?',
    relatedField: 'Software / IT',
    level: 'Junior',
    jobTitle: 'Junior Frontend Developer',
  },
  {
    question: 'How does DNS work in networking?',
    relatedField: 'Networking',
    level: 'Senior',
    jobTitle: 'Network Engineer',
  },
  {
    question: 'What is wireframing in UI/UX?',
    relatedField: 'Web UI',
    level: 'Mid-Level',
    jobTitle: 'UI Designer',
  },
  {
    question: 'What is talent acquisition in HR?',
    relatedField: 'HR',
    level: 'Mid-Level',
    jobTitle: 'HR Coordinator',
  },
  {
    question: 'What is HIPAA compliance in healthcare?',
    relatedField: 'Nursing',
    level: 'Senior',
    jobTitle: 'Healthcare Compliance Officer',
  },
  {
    question: 'What is Redux and how does it work?',
    relatedField: 'Software / IT',
    level: 'Associate',
    jobTitle: 'Associate Frontend Engineer',
  },
  {
    question: 'What is VLAN and why is it used?',
    relatedField: 'Networking',
    level: 'Mid-Level',
    jobTitle: 'Network Engineer',
  },
  {
    question: 'What are color theory principles in UI design?',
    relatedField: 'Web UI',
    level: 'Mid-Level',
    jobTitle: 'Visual Designer',
  },
  {
    question: 'What are behavioral interview techniques?',
    relatedField: 'HR',
    level: 'Senior',
    jobTitle: 'HR Consultant',
  },
  {
    question: 'What are common nursing interventions?',
    relatedField: 'Nursing',
    level: 'Junior',
    jobTitle: 'Staff Nurse',
  },
  {
    question: 'How does SSL/TLS encryption work?',
    relatedField: 'Networking',
    level: 'Senior',
    jobTitle: 'Cybersecurity Analyst',
  },
  {
    question: 'What are best practices for accessibility in UI design?',
    relatedField: 'Web UI',
    level: 'Mid-Level',
    jobTitle: 'Accessibility Specialist',
  },
  {
    question: 'What is employer branding in HR?',
    relatedField: 'HR',
    level: 'Senior',
    jobTitle: 'HR Marketing Specialist',
  },
  {
    question: 'What is the role of a nurse practitioner?',
    relatedField: 'Nursing',
    level: 'Senior',
    jobTitle: 'Nurse Practitioner',
  },
  {
    question: 'What is useEffect in React?',
    relatedField: 'Software / IT',
    level: 'Mid-Level',
    jobTitle: 'Frontend Developer',
  },
];
